import React from 'react';
import { Utensils, Target, Dumbbell, Zap, BookOpen } from 'lucide-react';
import { NutritionBlog } from '../components/nutrition/NutritionBlog';
import { PremiumPlan } from '../components/nutrition/PremiumPlan';

const blogs = [
  {
    id: 1,
    title: 'The Science of Protein Timing',
    excerpt: 'Learn when to consume protein for optimal muscle growth and recovery.',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80',
    readTime: '5 min'
  },
  {
    id: 2,
    title: 'Carb Cycling for Athletes',
    excerpt: 'Strategic carbohydrate manipulation for performance and body composition.',
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=800&q=80',
    readTime: '7 min'
  },
  {
    id: 3,
    title: 'Understanding Micronutrients',
    excerpt: 'The vital role of vitamins and minerals in athletic performance.',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=80',
    readTime: '6 min'
  },
  {
    id: 4,
    title: 'Meal Prep Mastery',
    excerpt: 'Efficient strategies for preparing healthy meals in advance.',
    image: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=800&q=80',
    readTime: '8 min'
  }
];

export function NutritionPage() {
  return (
    <div className="space-y-6 pb-20">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Nutrition</h1>
        <button className="theme-button px-4 py-2 rounded-lg">
          Get Premium
        </button>
      </div>

      {/* Premium Plan Banner */}
      <PremiumPlan />

      {/* Nutrition Blogs */}
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <div className="relative">
            <BookOpen className="w-6 h-6 text-primary" />
            <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
          </div>
          <h2 className="text-xl font-semibold">Featured Articles</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {blogs.map(blog => (
            <NutritionBlog key={blog.id} blog={blog} />
          ))}
        </div>
      </div>
    </div>
  );
}